import { TFunction } from "next-i18next";
import {
    SupportNewIcon,
    MobileRoundIcon,
    WhatsappRoundIcon,
} from "@smile2impress/components";
import { UTSLocale } from "@smile2impress/attraction-constants";

import contacts from "configs/contacts";

import { QuestionsContent } from "../Questions.types";

export default (t: TFunction, locale: UTSLocale): QuestionsContent => ({
    title: t("faq:questionsTitle"),
    contacts: [
        {
            icon: SupportNewIcon,
            label: t("global:helpCenter"),
            link: contacts.helpCenter[locale].link,
        },
        {
            icon: MobileRoundIcon,
            label: contacts.phone[locale].public,
            link: `tel:${contacts.phone[locale].link}`,
        },
        {
            icon: WhatsappRoundIcon,
            label: "WhatsApp",
            link: contacts.whatsapp[locale].link,
        },
    ],
    items: [
        {
            question: t("faq:questionsListItemQuestion1"),
            answer: t("faq:questionsListItemAnswer1"),
        },
        {
            question: t("faq:questionsListItemQuestion2"),
            answer: t("faq:questionsListItemAnswer2"),
        },
        {
            question: t("faq:questionsListItemQuestion3"),
            answer: t("faq:questionsListItemAnswer3"),
        },
        {
            question: t("faq:questionsListItemQuestion4"),
            answer: t("faq:questionsListItemAnswer4"),
        },
    ],
});
